const SECTIONS = [
  {
    title: "Article 1 — Objet et champ d'application",
    paras: [
      "Les présentes conditions générales de vente (CGV) définissent les modalités de vente en ligne des créations artisanales proposées par Labounite, notamment les vêtements, étoles, châles, ponchos et accessoires réalisés au crochet et au tricot.",
      "Elles s'appliquent à toute commande passée sur le site internet labouniteshop.fr, par un client particulier agissant à des fins non professionnelles.",
      "Toute commande implique la prise de connaissance des présentes CGV et leur acceptation avant la validation définitive de l'achat.",
    ],
  },
  {
    title: "Article 2 — Identification de la vendeuse",
    paras: [
      "La boutique Labounite est exploitée par :",
      { list: [
        "Nom et prénom : Mercadé Françoise",
        "Statut : Entrepreneuse individuelle sous le régime micro-entrepreneur",
        "Nom commercial : Labounite",
        "Adresse professionnelle : 13 lieu dit Chapsieres 15380 Anglards de Salers",
        "Numéro SIREN : 491409793",
        "Adresse électronique : labounite@gmail.com",
      ] },
      "Les coordonnées du médiateur de la consommation compétent sont indiquées à l'article 12 des présentes CGV.",
    ],
  },
  {
    title: "Article 3 — Produits et créations artisanales",
    paras: [
      "Labounite propose des créations artisanales réalisées au crochet et au tricot, confectionnées avec soin et attention.",
      "Chaque produit est présenté sur le site au moyen d'une description précisant ses caractéristiques essentielles, notamment, selon les informations disponibles, sa matière, ses couleurs, ses dimensions, ses conditions d'entretien et son prix.",
      "Les créations étant réalisées artisanalement, de légères variations peuvent exister d'un article à l'autre, notamment dans la texture, les finitions ou les dimensions. Ces particularités ne constituent pas des défauts.",
      "Les photographies sont réalisées afin de représenter les articles aussi fidèlement que possible. Des différences de rendu peuvent apparaître selon l'éclairage, l'écran utilisé ou les conditions d'affichage.",
      "Les éventuelles retouches de présentation des photographies ne doivent pas modifier les caractéristiques essentielles du produit vendu ni induire le client en erreur sur son apparence.",
      "Les produits sont proposés dans la limite des stocks disponibles ou, lorsque cela est indiqué, selon les modalités de confection précisées sur leur fiche descriptive.",
    ],
  },
  {
    title: "Article 4 — Prix et TVA",
    paras: [
      "Les prix sont indiqués en euros.",
      "Lorsque la vendeuse bénéficie effectivement de la franchise en base de TVA, les prix sont indiqués sans TVA applicable, conformément à l'article 293 B du Code général des impôts.",
      "Dans ce cas, la mention suivante figure sur le site et les documents de facturation concernés :",
      "« TVA non applicable, article 293 B du Code général des impôts. »",
      "Les prix applicables sont ceux affichés au moment de la commande.",
      "Les frais de livraison sont gratuits pour toutes les commandes livrées dans les zones de France desservies par la boutique. Aucun frais de livraison ne sera ajouté au montant de la commande.",
      "Le montant total à payer est affiché au client avant la validation définitive de son achat.",
    ],
  },
  {
    title: "Article 5 — Zone de livraison",
    paras: [
      "Labounite vend et expédie ses produits exclusivement en France métropolitaine et outre-mer.",
      "Aucune livraison n'est proposée à une adresse située à l'étranger.",
      "Le client est responsable de l'exactitude des informations communiquées lors de sa commande, notamment son nom, son adresse postale, son adresse électronique et, le cas échéant, son numéro de téléphone.",
      "En cas d'adresse erronée ou incomplète entraînant l'échec de la livraison, le client doit contacter Labounite afin de rechercher une solution adaptée. Les éventuels frais supplémentaires résultant directement de cette erreur pourront être mis à la charge du client.",
    ],
  },
  {
    title: "Article 6 — Commande",
    paras: [
      "Le client sélectionne les articles qu'il souhaite acheter et les ajoute à son panier.",
      "Avant de confirmer sa commande, il peut vérifier les produits sélectionnés, leurs quantités, leurs prix, ses coordonnées et l'adresse de livraison.",
      "Le client doit ensuite accepter les présentes CGV et valider sa commande au moyen du dispositif de confirmation prévu sur le site.",
      "La validation finale de la commande, matérialisée par un mécanisme indiquant explicitement l'obligation de paiement, entraîne l'obligation de régler le montant de l'achat.",
      "Un accusé de réception est adressé au client par courrier électronique, sous réserve de la communication d'une adresse valide.",
      "Labounite se réserve le droit de suspendre temporairement le traitement d'une commande en cas de suspicion raisonnable de fraude ou d'anomalie nécessitant une vérification. Toute annulation par la vendeuse sera notifiée au client.",
    ],
  },
  {
    title: "Article 7 — Paiement",
    paras: [
      "Le règlement est effectué au moyen des solutions de paiement proposées sur le site au moment de la commande.",
      "Les moyens de paiement disponibles sont précisés dans le parcours d'achat.",
      "Le paiement est réalisé par l'intermédiaire des dispositifs de paiement sécurisés éventuellement utilisés par la boutique.",
      "Labounite ne conserve pas les données complètes de carte bancaire lorsque leur traitement est assuré directement par un prestataire de paiement.",
      "La commande est préparée après confirmation du paiement, sauf indication contraire affichée lors de l'achat.",
    ],
  },
  {
    title: "Article 8 — Livraison",
    subsections: [
      {
        subtitle: "8.1. Frais de livraison",
        paras: [
          "La livraison est gratuite pour toutes les commandes expédiées en France dans les zones desservies par Labounite.",
          "Aucun montant minimum d'achat n'est exigé pour bénéficier de la gratuité, sauf condition particulière expressément annoncée avant la commande.",
        ],
      },
      {
        subtitle: "8.2. Modes de livraison",
        paras: [
          "Les modes de livraison disponibles, les éventuelles restrictions et les délais estimés sont indiqués sur le site ou au cours de la commande.",
          "Le transporteur et le mode d'expédition peuvent varier selon les caractéristiques du colis et les services disponibles.",
          "Lorsqu'un numéro de suivi est disponible, il est communiqué au client ou mis à sa disposition.",
        ],
      },
      {
        subtitle: "8.3. Délais de livraison",
        paras: [
          "Le délai de livraison applicable est communiqué au client avant la conclusion de la commande.",
          "Lorsque l'article doit être confectionné après l'achat, le délai de préparation ou de confection est précisé sur la fiche produit ou au cours du parcours de commande.",
          "À défaut de date ou de délai convenu, la livraison doit intervenir sans retard injustifié et au plus tard dans les trente jours suivant la conclusion du contrat, conformément aux dispositions légales applicables.",
          "En cas de retard, le client dispose des droits prévus par le Code de la consommation, notamment la possibilité, dans les conditions légales, de demander la livraison dans un délai supplémentaire raisonnable ou, à défaut, de résoudre le contrat.",
        ],
      },
      {
        subtitle: "8.4. Réception du colis",
        paras: [
          "Le client est invité à vérifier l'état du colis à sa réception.",
          "En cas de colis endommagé ou présentant des signes d'ouverture, il est recommandé de conserver les éléments utiles et de contacter rapidement Labounite.",
          "Cette vérification ne limite pas les droits du client au titre des garanties légales ou des règles applicables au transport.",
          "Le risque de perte ou d'endommagement du produit est transféré au consommateur au moment où celui-ci, ou un tiers désigné par lui autre que le transporteur, prend physiquement possession du bien, conformément aux dispositions légales.",
        ],
      },
    ],
  },
  {
    title: "Article 9 — Droit de rétractation",
    subsections: [
      {
        subtitle: "9.1. Délai légal",
        paras: [
          "Pour les commandes conclues à distance, le client consommateur dispose, en principe, d'un délai de quatorze jours calendaires pour exercer son droit de rétractation, sans avoir à justifier sa décision ni supporter de pénalité.",
          "Pour la vente de biens, ce délai commence à courir le lendemain de la réception du produit par le client ou par le tiers désigné par lui, autre que le transporteur.",
          "Lorsque plusieurs produits d'une même commande sont livrés séparément, les règles légales relatives au point de départ du délai s'appliquent.",
        ],
      },
      {
        subtitle: "9.2. Modalités d'exercice",
        paras: [
          "Le client peut notifier sa décision de se rétracter au moyen du formulaire type figurant ci-dessous, par courrier électronique à labounite@gmail.com, par courrier postal à l'adresse de l'entreprise, ou par tout autre moyen permettant d'établir la date d'envoi.",
          "La notification doit exprimer sans ambiguïté la volonté du client de se rétracter et être transmise avant l'expiration du délai légal.",
          "Lorsque la commande est conclue par l'intermédiaire d'une interface en ligne, Labounite met en place la fonctionnalité de rétractation directe exigée par la réglementation applicable, de manière visible et accessible.",
          "Un accusé de réception est transmis au client lorsque la rétractation est exercée par la fonctionnalité en ligne.",
        ],
      },
      {
        subtitle: "9.3. Exceptions au droit de rétractation",
        paras: [
          "Le droit de rétractation ne s'applique pas aux produits entrant dans une exception légale.",
          "En particulier, il peut être exclu pour les biens confectionnés selon les spécifications du consommateur ou nettement personnalisés, conformément à l'article L221-28 du Code de la consommation.",
          "Le simple fait qu'un vêtement soit fabriqué à la main ou confectionné après la commande ne suffit pas, à lui seul, à exclure le droit de rétractation.",
          "Lorsqu'une exception est applicable, le client en est informé avant la conclusion de la commande.",
        ],
      },
      {
        subtitle: "9.4. Retour des produits",
        paras: [
          "Après avoir communiqué sa décision de se rétracter, le client doit renvoyer les produits concernés au plus tard dans les quatorze jours suivant cette notification.",
          "Les modalités et l'adresse de retour sont communiquées par Labounite.",
          "Sauf prise en charge volontaire par Labounite, les frais directs de retour sont à la charge du client lorsque celui-ci a été correctement informé de cette obligation avant la commande.",
          "Les produits doivent être manipulés avec le soin nécessaire pour permettre de vérifier leur nature, leurs caractéristiques et leur état.",
          "Le client peut être tenu responsable d'une dépréciation résultant de manipulations autres que celles nécessaires à cette vérification, dans les conditions prévues par la loi.",
          "Les retours ne doivent pas être refusés automatiquement en raison d'un simple déballage ou d'une manipulation nécessaire à l'examen du produit.",
        ],
      },
      {
        subtitle: "9.5. Remboursement",
        paras: [
          "En cas de rétractation valable, Labounite rembourse les sommes dues, y compris les frais de livraison initialement facturés s'il y en avait, au plus tard dans les quatorze jours suivant la date à laquelle elle a été informée de la décision de rétractation.",
          "La livraison étant gratuite, aucun frais de livraison initial n'est facturé au client.",
          "Pour une vente de biens, Labounite peut différer le remboursement jusqu'à récupération des produits ou jusqu'à ce que le client fournisse une preuve de leur expédition, la date retenue étant celle du premier de ces faits.",
          "Le remboursement est effectué au moyen du même moyen de paiement que celui utilisé lors de la transaction, sauf accord exprès du client pour un autre moyen n'occasionnant pas de frais supplémentaires.",
        ],
      },
    ],
  },
  {
    title: "Article 10 — Formulaire type de rétractation",
    paras: [
      "À l'attention de :",
    ],
    address: {
      to: "Labounite — Mercadé Françoise",
      lines: [
        "Adresse : 13 lieu dit Chapsieres 15380 Anglards de Salers",
        "E-mail : labounite@gmail.com",
      ],
    },
    afterAddress: [
      "Je vous notifie par la présente ma rétractation du contrat portant sur la vente du ou des produits ci-dessous :",
      { list: [
        "Produit(s) concerné(s) : [à compléter]",
        "Commandé le : [date]",
        "Reçu le : [date]",
        "Nom du consommateur : [nom et prénom]",
        "Adresse du consommateur : [adresse complète]",
        "Date de la demande : [date]",
      ] },
      "Signature du consommateur, uniquement en cas de notification sur papier :",
      "[Signature]",
    ],
  },
  {
    title: "Article 11 — Garanties légales",
    paras: [
      "Les produits vendus par Labounite bénéficient des garanties légales applicables, notamment :",
      { list: [
        "la garantie légale de conformité prévue par le Code de la consommation ;",
        "la garantie des vices cachés prévue par les articles 1641 et suivants du Code civil.",
      ] },
      "Ces garanties s'appliquent indépendamment de toute garantie commerciale éventuellement proposée.",
    ],
    subsections: [
      {
        subtitle: "Garantie légale de conformité",
        paras: [
          "Le consommateur peut demander la mise en conformité du produit dans les conditions prévues par les articles L217-3 et suivants du Code de la consommation.",
          "Les remèdes légaux, notamment la réparation ou le remplacement lorsque ces solutions sont applicables, sont mis en œuvre conformément aux conditions prévues par la loi.",
        ],
      },
      {
        subtitle: "Garantie des vices cachés",
        paras: [
          "Le consommateur peut également invoquer la garantie des vices cachés lorsqu'un défaut caché répond aux conditions définies par les articles 1641 et suivants du Code civil.",
          "Pour toute demande, le client est invité à contacter Labounite en décrivant le problème rencontré et en joignant, si possible, des photographies utiles.",
          "Les particularités normales du travail artisanal, lorsqu'elles correspondent à la description du produit et ne constituent pas un défaut de conformité, ne sont pas assimilées automatiquement à des défauts.",
          "Aucune disposition des présentes CGV ne limite les droits impératifs du consommateur.",
        ],
      },
    ],
  },
  {
    title: "Article 12 — Réclamations et médiation de la consommation",
    paras: [
      "En cas de difficulté concernant une commande, un produit, un paiement ou une livraison, le client est invité à contacter en premier lieu Labounite :",
      { list: [
        "E-mail : labounite@gmail.com",
        "Adresse postale : 13 lieu dit Chapsieres 15380 Anglards de Salers",
      ] },
      "Labounite s'efforcera de rechercher une solution amiable.",
      "Si le litige n'a pas pu être résolu après une réclamation écrite préalable, le consommateur peut saisir gratuitement le médiateur de la consommation compétent, dans les conditions légales.",
      { list: [
        "Médiateur de la consommation : CM2C",
        "Adresse postale : 49 rue de Ponthieu – 75008 PARIS",
        "Site internet : www.cm2c.net",
      ] },
    ],
  },
  {
    title: "Article 13 — Données personnelles",
    paras: [
      "Les données personnelles collectées lors d'une commande sont utilisées pour gérer les achats, les paiements, la préparation des produits, la livraison, les demandes des clients et les obligations légales.",
      "Le traitement des données est effectué conformément à la réglementation applicable en matière de protection des données personnelles.",
      "Les informations détaillées sur les finalités, les bases légales, les durées de conservation, les destinataires et les droits des personnes concernées figurent dans la politique de confidentialité du site.",
      "Pour toute question relative à ses données ou pour exercer ses droits, le client peut contacter : labounite@gmail.com.",
    ],
  },
  {
    title: "Article 14 — Propriété intellectuelle",
    paras: [
      "Les textes, photographies, illustrations, éléments graphiques et autres contenus originaux présents sur le site sont protégés par les règles applicables en matière de propriété intellectuelle.",
      "Toute reproduction ou exploitation non autorisée de ces éléments est interdite, sous réserve des exceptions prévues par la loi.",
      "L'achat d'un produit ne confère aucun droit de propriété intellectuelle sur les contenus du site ou sur les créations originales de Labounite.",
    ],
  },
  {
    title: "Article 15 — Responsabilité",
    paras: [
      "Labounite est responsable de la bonne exécution des obligations découlant du contrat de vente, dans les conditions prévues par la législation applicable.",
      "Sa responsabilité ne saurait être exclue lorsque la loi impose qu'elle soit engagée.",
      "En cas de force majeure au sens du droit applicable, les obligations concernées sont appréciées conformément aux dispositions légales.",
      "Les présentes dispositions ne privent pas le consommateur de ses droits concernant la livraison, la conformité des produits, la rétractation ou les garanties légales.",
    ],
  },
  {
    title: "Article 16 — Droit applicable et litiges",
    paras: [
      "Les présentes CGV sont soumises au droit français.",
      "En cas de litige, le client et Labounite chercheront, dans la mesure du possible, une solution amiable.",
      "À défaut de résolution amiable ou de médiation, le litige pourra être porté devant les juridictions compétentes, conformément aux règles légales applicables.",
      "Aucune clause des présentes CGV ne prive le consommateur des règles impératives de compétence juridictionnelle dont il bénéficie.",
    ],
  },
  {
    title: "Article 17 — Contact",
    paras: [
      "Pour toute question relative aux produits, aux commandes, aux paiements, aux livraisons, aux retours ou aux garanties, le client peut contacter Labounite :",
      { list: [
        "E-mail : labounite@gmail.com",
        "Adresse postale : 13 lieu dit Chapsieres 15380 Anglards de Salers",
      ] },
      "Les présentes CGV sont accessibles sur le site internet avant la validation de toute commande.",
    ],
  },
];

const Para = ({ p }) =>
  typeof p === "string" ? (
    <p className="leading-relaxed text-[#1F1C18]/85">{p}</p>
  ) : (
    <ul className="space-y-1.5 pl-5 list-disc marker:text-terracotta text-[#1F1C18]/85">
      {p.list.map((li) => <li key={li}>{li}</li>)}
    </ul>
  );

const SubSection = ({ sub }) => (
  <div className="space-y-2 mt-4">
    <h3 className="font-serif-display text-lg text-[#1F1C18]/90">{sub.subtitle}</h3>
    {sub.paras.map((p, i) => <Para key={i} p={p} />)}
  </div>
);

export default function TermsOfSale() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-testid="terms-of-sale-page">
      <p className="font-accent text-3xl text-terracotta -rotate-2 mb-2">Labounite</p>
      <h1 className="font-serif-display text-4xl sm:text-5xl mb-3">Conditions générales de vente</h1>
      <p className="text-sm text-[#6B655C] mb-10" data-testid="terms-of-sale-updated">Dernière mise à jour : 28 octobre 2026</p>
      <div className="bg-white/70 backdrop-blur-md rounded-3xl p-6 sm:p-10 space-y-10">
        {SECTIONS.map((s) => (
          <section key={s.title} className="space-y-3">
            <h2 className="font-serif-display text-2xl text-terracotta">{s.title}</h2>
            {s.paras && s.paras.map((p, i) => <Para key={i} p={p} />)}
            {s.address && (
              <div className="bg-white/60 border border-terracotta/20 rounded-xl p-4 space-y-1 text-[#1F1C18]/85">
                <p className="font-semibold">{s.address.to}</p>
                {s.address.lines.map((l, i) => <p key={i}>{l}</p>)}
              </div>
            )}
            {s.afterAddress && s.afterAddress.map((p, i) => <Para key={`aa-${i}`} p={p} />)}
            {s.subsections && s.subsections.map((sub) => (
              <SubSection key={sub.subtitle} sub={sub} />
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
